import type { IssueViewModel } from '@trinnvis/dabih-api-client';

/**
 * Issues registered before new processing conditions are evaluated using previous criteria.
 *
 * @param issue The issue to evaluate
 */
export function previousIsIssueProcessed(issue: IssueViewModel): boolean {
  if (issue.evaluatedDate && issue.evaluatedBy) {
    return true;
  }
  if (issue.evaluated) {
    // skal evalueres
    return false;
  }
  if (issue.implementedMeasure) {
    return true;
  }
  if (issue.requiresMeasures) {
    return false;
  }
  return !!(issue.processedDate && issue.processedBy);
}
